import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';
import { BiBuilding, BiBriefcase, BiStore, BiCodeBlock } from 'react-icons/bi';

const AUDIENCE_IDS = ['smb', 'legal', 'trade', 'agency'];
const AUDIENCE_ICONS = {
  smb: BiBuilding,
  legal: BiBriefcase,
  trade: BiStore,
  agency: BiCodeBlock,
};

const MailServerAudiences = () => {
  const { t } = useTranslations();
  const audiences = AUDIENCE_IDS.map((id) => ({
    icon: AUDIENCE_ICONS[id],
    title: t(`managedServices_mailServer_audience_${id}_title`),
    desc: t(`managedServices_mailServer_audience_${id}_desc`),
    points: [1, 2, 3, 4]
      .map((n) => t(`managedServices_mailServer_audience_${id}_point${n}`))
      .filter((text) => text && !text.includes('managedServices_mailServer_')),
  }));

  return (
    <section className="ms-section ms-section--alt ms-section--audiences">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_mailServer_audiences_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_mailServer_audiences_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_mailServer_audiences_subtitle')}
          </p>
        </div>
        <div className="row">
          {audiences.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="col-lg-6 col-md-6 mb-4">
                <div className="ms-audience-card ms-audience-card--enhanced">
                  <div className="ms-audience-card__icon-wrap">
                    <Icon />
                  </div>
                  <h4>{item.title}</h4>
                  <p className="ms-audience-card__intro">{item.desc}</p>
                  {item.points.length > 0 && (
                    <ul className="ms-audience-card__list">
                      {item.points.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MailServerAudiences;
